import React, { Component } from "react";
import { connect } from "react-redux";
import { getPoseById, editPose } from "../../store/actions/poseActions";
import { withRouter } from "react-router";
import { Yoga, Overview, Link, Steps } from 'grommet-icons';

const allPoseTypes = ["Balance", "Core", "Backbend", "Inversion", "Standing", "Restorative", "Chest Opening"];

class EditPose extends Component {
  constructor() {
    super();
    this.state = {
      name: "",
      description: "",
      imageUri: "",
      types: [],
      level: null
    };
  }

  componentWillReceiveProps = (nextProps) => {
    if(nextProps.pose) {
      this.setState({
        ...nextProps.pose
      });
    }
  }

  componentDidMount = () => {
    this.props.getPoseById(this.props.match.params.id);

    var elems = document.querySelectorAll("select");
    window.M.FormSelect.init(elems, {});
  } 

  handleChange = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };

  handlePoseTypeChange = e => {
    if (e.target.checked) {
      this.setState({
        types: [...this.state.types, e.target.value]
      });
    } else {
      this.setState({
        types: this.state.types.filter(pt => pt !== e.target.value)
      });
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.editPose(this.props.match.params.id, this.state);
    this.props.history.push("/admin/poses");
  };

  render() {
    const poseTypeCheckboxes = allPoseTypes.map(poseType => {
      return (
        <p key={poseType}>
          <label>
            <input
              id={`poseType${poseType}`}
              type="checkbox"
              value={poseType}
              onChange={this.handlePoseTypeChange}
              checked={this.state.types.includes(poseType)}
            />
            <span>
              {poseType[0].toUpperCase() + poseType.slice(1)}
            </span>
          </label>
        </p>
      );
    });

    return (
      <div className="row">
        <form onSubmit={this.handleSubmit} className="col s12">
          
          <div className="row">
            <div className="input-field col s12">
              <i className="material-icons prefix"><Yoga color="black" size="medium"/></i>
              <input
                type="text"
                name="name"
                id="name"
                className="autocomplete"
                value={this.state.name}
                onChange={this.handleChange}
              />
            </div>
          </div>

          <div className="row">
            <div className="input-field col s12">
              <i className="material-icons prefix"><Overview color="black" size="medium"/></i>
              <input
                type="text"
                id="description"
                value={this.state.description}
                onChange={this.handleChange}
                className="autocomplete"
              />
            </div>
          </div>

          <div className="row">
            <div className="input-field col s12">
            <i className="material-icons prefix"><Steps color="black" size="medium"/></i>
              <select id="level" name="option" defaultValue={this.state.level} onChange={this.handleChange}>
                <option value="" disabled>
                  Pose level
                </option>
                <option value="Beginner">Beginner</option>
                <option value="Intermediate">Intermediate</option>
                <option value="Advanced">Advanced</option>
              </select>
            </div>
          </div>

          <div className="row">
            <div className="input-field col s12">
              <i className="material-icons prefix"><Link color="black" size="medium"/></i>
              <input
                type="text"
                id="imageUri"
                value={this.state.imageUri}
                className="autocomplete"
                onChange={this.handleChange}
              />
            </div>
          </div>

          <div className="row">{poseTypeCheckboxes}</div>

          <div className="row">
            <div className="input-field col s12">
              <button
                className="btn waves-effect waves-light"
                type="submit"
                name="action"
              >
                Update Pose
                <i className="material-icons right">save</i>
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    pose: state.admin.pose
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getPoseById: (id) => dispatch(getPoseById(id)),
    editPose: (id, pose) => dispatch(editPose(id, pose)) 
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EditPose)
);
